import { withRouter } from 'react-router-dom';
import { DayPicker as Component } from './DayPicker';

export const DayPicker = withRouter(Component);
